import { getStoryblokLink } from "utilities/getStoryblokLink"
import Image from "next/image"
import Link from "next/link"

export default function SponsorsSection({ sponsors }) {
  return (
    <section className="px-5 py-10 lg:py-14">
      <div className="mx-auto max-w-screen-xl flex flex-col gap-8">
        <h2 className="text-center">Our Sponsors</h2>
        <div className="flex justify-center ">
          {sponsors.featured.map((sponsor) => (
            <Link key={sponsor._uid} href={getStoryblokLink(sponsor?.content?.link)} target="_blank">
              <div className="max-w-[300px]">
                <Image
                  src={sponsor?.content?.logo?.filename}
                  alt="Sponsor Logo"
                  height={300}
                  width={400}
                  style={{ objectFit: "cover" }}
                  target="_blank"
                />
              </div>
            </Link>
          ))}
        </div>
        <div className="flex flex-col md:flex-row justify-center items-center gap-8">
          {sponsors.standard.map((sponsor) => (
            <div key={sponsor._uid} className="max-w-[400px] lg:max-w-[200px]">
              <Link key={sponsor._uid} href={getStoryblokLink(sponsor?.content?.link)} target="_blank">
                <Image
                  src={sponsor?.content?.logo?.filename}
                  alt="Sponsor Logo"
                  className="block"
                  height={300}
                  width={500}
                  style={{ width: "100%", height: "auto" }}
                  target="_blank"
                />
              </Link>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}
